import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/scientific-calculator',
  component: () => import('../../routes/ScientificCalculator.svelte'),
  card: {
    id: 'scientific-calculator',
    title: 'Scientific Calculator',
    description: 'Perform advanced math operations including trigonometry, logarithms, powers, roots, and factorials.',
    icon: 'calculate',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/scientific-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Scientific Calculator – Advanced Math Operations',
    description:
      'Free scientific calculator with trigonometric functions, logarithms, powers, roots, factorials, and more. Perform complex math calculations instantly.',
  },
};

export default meta;
